import React, { useState, useEffect } from "react";

const MANAGER_URL = process.env.REACT_APP_MANAGER_URL;
const MANAGER_RESALE_URL = process.env.REACT_APP_MANAGER_RESALE_URL;
const STUDIO_URL = process.env.REACT_APP_STUDIO_URL;
const STUDIO_RESALE_URL = process.env.REACT_APP_STUDIO_RESALE_URL;
const PUBLIC_DATE_ENDPOINT = "https://worldtimeapi.org/api/ip";

function getOrigin(url) {
  if (!url) return "";
  try {
    return new URL(url).origin;
  } catch (e) {
    return "";
  }
}

function getResaleNameFromPath(pathname) {
  var segments = (pathname || "").split("/").filter(Boolean);
  if (!segments.length) return "";

  var first = (segments[0] || "").toLowerCase();
  var second = (segments[1] || "").toLowerCase();
  var staticRoots = ["home", "passwordreset", "login"];

  if (staticRoots.indexOf(first) !== -1) return "";
  if (segments.length > 1 && second !== "home" && second !== "login") return "";

  return segments[0];
}

function getStudioRedirectUrl() {
  if (typeof window === "undefined") return STUDIO_URL;

  var currentOrigin = window.location.origin;
  var managerOrigin = getOrigin(MANAGER_URL);
  var managerResaleOrigin = getOrigin(MANAGER_RESALE_URL);
  var studioResaleOrigin = getOrigin(STUDIO_RESALE_URL);

  if (currentOrigin === managerResaleOrigin && studioResaleOrigin) {
    var resaleName = getResaleNameFromPath(window.location.pathname);
    return resaleName
      ? studioResaleOrigin + "/" + resaleName
      : STUDIO_URL;
  }

  if (currentOrigin === managerOrigin) return STUDIO_URL;

  return STUDIO_URL;
}

function useIsMobile(breakpoint) {
  var mql = typeof window !== "undefined"
    ? window.matchMedia("(max-width: " + (breakpoint || 768) + "px)")
    : null;
  var [matches, setMatches] = useState(mql ? mql.matches : false);

  useEffect(function () {
    if (!mql) return;
    function handler(e) { setMatches(e.matches); }
    mql.addListener(handler);
    return function () { mql.removeListener(handler); };
  }, [mql]);

  return matches;
}

function getNextDayDate(date) {
  var nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + 1);
  return nextDate;
}

function formatDate(date) {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

function fetchCurrentDateFromApi() {
  return fetch(PUBLIC_DATE_ENDPOINT)
    .then(function (response) {
      if (!response.ok) throw new Error("Failed to fetch public date");
      return response.json();
    })
    .then(function (data) {
      var datetime = data && data.datetime ? data.datetime : null;
      if (!datetime) throw new Error("Invalid public date response");

      var parsedDate = new Date(datetime);
      if (Number.isNaN(parsedDate.getTime())) throw new Error("Invalid datetime");

      return parsedDate;
    });
}

function BetaBanner() {
  var isLight = localStorage.getItem("theme") === "light";
  var isMobile = useIsMobile(768);
  var studioRedirectUrl = getStudioRedirectUrl();
  var [endDate, setEndDate] = useState(null);

  useEffect(function () {
    var isMounted = true;

    fetchCurrentDateFromApi()
      .then(function (serverDate) {
        if (!isMounted) return;
        setEndDate(getNextDayDate(serverDate));
      })
      .catch(function () {
        if (!isMounted) return;
        setEndDate(null);
      });

    return function () {
      isMounted = false;
    };
  }, []);

  if (!studioRedirectUrl) return null;

  var bannerBg = "#ffeb3b";
  var bannerColor = "#000";
  var bannerShadow = isLight
    ? "0 2px 12px rgba(0,0,0,0.08)"
    : "0 2px 12px rgba(0,0,0,0.15)";
  var btnBg = "#000";
  var btnColor = "#ffeb3b";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1051,
        background: bannerBg,
        color: bannerColor,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: "center",
        gap: isMobile ? 8 : 16,
        padding: isMobile ? "10px 12px" : "8px 24px",
        boxShadow: bannerShadow,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontSize: isMobile ? 14 : 18,
        marginLeft: isMobile ? 0 : "20%",
        marginRight: isMobile ? 0 : "20%",
      }}
    >
      <span
        style={{
          textAlign: isMobile ? "center" : "left",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <span>
          Comece a usar o <strong>Eprice Studio</strong> — o <strong>Eprice Manager</strong> será descontinuado.
        </span>
        <span style={{ fontWeight: 600, fontSize: isMobile ? 13 : 16 }}>
          {endDate ? (
            <>
              Encerramento em <strong>{formatDate(endDate)}</strong>. Migre agora para não perder o acesso.
            </>
          ) : (
            <>Encerramento amanhã. Migre agora para não perder o acesso.</>
          )}
        </span>
      </span>

      <a
        href={studioRedirectUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: btnBg,
          color: btnColor,
          padding: isMobile ? "5px 14px" : "6px 18px",
          borderRadius: 6,
          fontWeight: 600,
          fontSize: isMobile ? 14 : 18,
          textDecoration: "none",
          whiteSpace: "nowrap",
        }}
      >
        Acessar o Eprice Studio
      </a>
    </div>
  );
}

export default BetaBanner;
